import fetch from '../utils/fetch'

export function getWxShopsList (query) {
  return fetch({
    url: '/shops/wxshops',
    method: 'get',
    params: query
  })
}

export function getWxShopsDetail (wxShopId) {
  return fetch({
    url: '/shops/wxshops/' + wxShopId,
    method: 'get'
  })
}

export function createWxShops (query) {
  return fetch({
    url: '/shops/wxshops',
    method: 'post',
    data: query
  })
}

export function updateWxShops (wxShopId, query) {
  return fetch({
    url: '/shops/wxshops/' + wxShopId,
    method: 'put',
    data: query
  })
}

export function setDefaultShop (query) {
  return fetch({
    url: '/shops/wxshops/setDefaultShop',
    method: 'post',
    data: query
  })
}

export function setResource (query) {
  return fetch({
    url: '/shops/wxshops/setShopResource',
    method: 'post',
    data: query
  })
}

export function deleteWxShops (wxShopId) {
  return fetch({
    url: '/shops/wxshops/' + wxShopId,
    method: 'delete',
  })
}

export function syncWxShops (query) {
  return fetch({
    url: '/shops/wxshops/sync',
    method: 'get'
  })
}

export function getSettingWxShops (query) {
  return fetch({
    url: '/shops/wxshops/setting',
    method: 'get'
  })
}

export function putSettingWxShops (query) {
  return fetch({
    url: '/shops/wxshops/setting',
    method: 'put',
    data: query
  })
}

export function createSalesperson(query) {
  return fetch({
    url: '/shops/salesperson',
    method: 'post',
    data: query
  })
}

export function getSalespersonList(query) {
  return fetch({
    url: '/shops/salesperson',
    method: 'get',
    params: query
  })
}

export function deleteSalesperson (salesperson_id) {
  return fetch({
    url: '/shops/salesperson/' + salesperson_id,
    method: 'delete'
  })
}

export function updateSalesperson (salesperson_id, query) {
  return fetch({
    url: '/shops/salesperson/' + salesperson_id,
    method: 'put',
    data: query
  })
}

export function getCommentList (query) {
  return fetch({
    url: '/comments',
    method: 'get',
    params: query
  })
}

export function upadteComment (comment_id, query) {
  return fetch({
    url: '/comment/' + comment_id,
    method: 'patch',
    params: query
  })
}

export function setShopStatus (query) {
  return fetch({
    url: '/shops/wxshops/setShopStatus',
    method: 'post',
    data: query
  })
}

export function getRelShopList(query) {
  return fetch({
    url: '/shops/saleperson/shoplist',
    method: 'get',
    params: query
  })
}

export function getSalespersonInfo(query) {
  return fetch({
    url: '/shops/saleperson/getinfo',
    method: 'get',
    params: query
  })
}

export function getDistributionConfig () {
  return fetch({
    url: '/distribution/config',
    method: 'get'
  })
}

export function setDistributionConfig (params) {
  return fetch({
    url: '/distribution/config',
    method: 'post',
    data: params
  })
}

export function getProfitStatistics(query) {
  return fetch({
    url: '/profit/statistics',
    method: 'get',
    params: query
  })
}

export function profitExport (query) {
  return fetch({
    url: '/profit/export',
    method: 'get',
    params: query
  })
}

export function getSalesperosnTask (query) {
  return fetch({
    url: '/salesperson/task',
    method: 'get',
    params: query
  })
}

export function getSalesperosnTaskInfo (task_id) {
  return fetch({
    url: '/salesperson/task/' + task_id,
    method: 'get'
  })
}

export function createSalesperosnTask (params) {
  return fetch({
    url: '/salesperson/task',
    method: 'post',
    data: params
  })
}

export function updateSalesperosnTask (task_id, params) {
  return fetch({
    url: '/salesperson/task/' + task_id,
    method: 'put',
    data: params
  })
}

export function cancleSalesperosnTask (task_id, params) {
  return fetch({
    url: '/salesperson/task/' + task_id,
    method: 'delete',
    data: params
  })
}

export function getSalesperosnTaskStatistics (query) {
  return fetch({
    url: '/salesperson/task/statistics',
    method: 'get',
    params: query
  })
}

// 获取导购登录记录
export function getSalespersonLoginLog (query) {
  return fetch({
    url: '/shops/saleperson/signlogs',
    method: 'get',
    params: query
  })
}

export function getDistributorShowRuleList (query) {
  return fetch({
    url: '/distributor/showRule/list',
    method: 'get',
    params: query
  })
}

export function getDistributorShowRuleDetail (query) {
  return fetch({
    url: '/distributors/showRule/detail',
    method: 'get',
    params: query
  })
}

export function createDistributorShowRule (query) {
  return fetch({
    url: '/distributors/showRule',
    method: 'post',
    data: query
  })
}

export function updateDistributorShowRule (query) {
  return fetch({
    url: '/distributors/showRule',
    method: 'put',
    data: query
  })
}
